import { Tooltip } from "monday-ui-react-core";
import { Workspace } from "monday-ui-react-core/dist/allIcons";
import { useMemo } from "react";
import { useTheme } from "styled-components";

import { MondayIcon } from "@/components/MondayBasics/MondayIcon";
import { IMMEDIATE_SHOW_DELAY } from "@/components/MondayBasics/MondayWorkspaceIcon/constants/tooltipConstant";
import { get } from "@/utils/theme-gets";

type MainWorkspaceIcon = {
  name: string;
  iconColor?: string;
  size?: number;
};

const DEFAULT_SIZE = 20;
export const MainWorkspaceIcon: React.FC<MainWorkspaceIcon> = ({ name, iconColor, size }) => {
  const theme = useTheme();
  const iconSize = size || DEFAULT_SIZE;

  const workspace = useMemo(() => <Workspace width={iconSize} height={iconSize} />, [iconSize]);

  return (
    <Tooltip content={name} immediateShowDelay={IMMEDIATE_SHOW_DELAY} containerSelector="body">
      <MondayIcon
        Icon={workspace}
        size={iconSize}
        color={iconColor || (get(theme, "color.foreground.icon.primary", "") as string)}
      />
    </Tooltip>
  );
};
